import styled from 'styled-components';

export const MainOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
    `
);

export const MainInnerWrap = styled.div(
    props => `
        max-width: 120rem;
        margin:0 auto;
        width:100%;
        flex-direction: column;
    `
);

export const MainContentWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        padding: ${props.theme.spacing.large.l40} 0;
        @media only screen and (min-width:320px) and (max-width: 767px){
            padding: ${props.theme.spacing.large.l40} ${props.theme.spacing.large.l15};
        }
    `
);

export const ContentInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const ConentHeadText = styled.h3(
    props => `
        font-size: ${props.theme.font.large.font20};
        color: ${props.theme.colors.red.darkd0};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-bottom: ${props.theme.spacing.large.l10};
    `
);

export const ContentSubHeadText = styled.h5(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding: ${props.theme.spacing.base} 0;
    `
);


export const InfoContentWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.base} 0 ${props.theme.spacing.large.l20};
        flex-direction: column;
    `
);

export const InfoText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.small.s8};
        line-height: 1.3;
    `
);

export const InfoTextBold = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.small.s4};
        padding-top: ${props.theme.spacing.small.s5};
        font-weight: ${props.theme.font.fontWeight.bold};
        line-height: 1.3;
    `
)

export const InfoList = styled.ul(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        list-style-type: disc;
        list-style-position: inside;
        padding-left: 30px;

        li{
            font-size: ${props.theme.font.large.font14};
            color: ${props.theme.colors.black.base};
            padding-bottom: ${props.theme.spacing.small.s8};
            line-height: 1.3;
        }
    `
);
